
<div class="modal-dialog confirm-dialog" style="min-width:830px;">
  <div class="modal-content">
    <div class="modal-header flex-column">
      <button class="close" type="button" (click)="cancel()">&times;</button>
      <h4 class="modal-title w-100 font-weight-normal">Associate {{typeModal === 'software' ? 'Software' : 'Standalone Accessory'}} to a Device</h4><span class="mt-3">{{typeModal === 'software' ? 'Software' : 'Standalone Accessory'}}:<strong class="ml-2">{{solution.description}}</strong></span>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div *ngIf="loading">
        <md-spinner-block></md-spinner-block>
      </div>
      <div *ngIf="!loading">
        <div class="row">
          <div class="col-12">
            <list-controls class="mb-4" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
          </div>
        </div>
        <div class="row spreadsheet-container mx-auto">
          <table class="table table-bordered border-top-0" *ngIf="assetsDisplay.length">
            <thead>
              <tr class="tr-header-edit-asset" style="font-size: 16px;">
                <th class="border-right-0"></th>
                <th class="border-left-0">Associate to this Device</th>
                <th class="border-left-0">Serial Number</th>
                <th class="border-left-0">Install Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="pl-3 text-center border-right-0">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" [name]="&quot;selectedAsset&quot;" autoLinkToLabel [checked]="solution.assetId === &quot;&quot;" (change)="setSelection(&quot;&quot;, &quot;&quot;)">
                  </div>
                </td>
                <td class="border-left-0">None</td>
              </tr>
              <tr *ngFor="let asset of assetsDisplay">
                <td class="pl-3 text-center border-right-0">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" [name]="&quot;selectedAsset&quot;" autoLinkToLabel [checked]="solution.assetId === asset.id" (change)="setSelection(asset.id, asset.description)">
                  </div>
                </td>
                <td class="border-left-0">{{asset.description}}</td>
                <td class="border-left-0">{{asset.serialNumber}}</td>
                <td class="border-left-0">{{asset.installDate | date: 'yyyy-MM-dd' : 'UTC'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="row w-100 py-5" *ngIf="!assetsDisplay.length">
            <p class="text-center w-100">There are no {{typeModal === 'software' ? 'software' : 'standalone accessories'}} to display.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary btn-sm px-5" type="button" (click)="cancel()">Cancel</button>
      <button class="btn btn-outline-primary btn-sm px-5 ml-3" type="button" [disabled]="!selected" (click)="saveSelection()">Save</button>
    </div>
  </div>
</div>